import { MathX } from "../../../../math/MathX";
import { DataType } from "../../../evaluators/DataType";
import { LomaFunction } from "../LomaFunction";
import { LomaVariable } from "../LomaVariable";
import { DataTypes } from "./DataTypes";

export class Exponentation
{
  static variables:LomaVariable<any>[] = 
  [ 
    LomaVariable.create( "E", Math.E, DataTypes.Number ).setInfo(
      {
        en: "Euler's number and the base of natural logarithms"
      }
    ),

    LomaVariable.create( "LN10", Math.LN10, DataTypes.Number ).setInfo(
      {
        en: "Natural logarithm of 10"
      }
    ),

    LomaVariable.create( "LN2", Math.LN2, DataTypes.Number ).setInfo(
      {
        en: "Natural logarithm of 2"
      }
    ),

    LomaVariable.create( "LOG10E", Math.LOG10E, DataTypes.Number ).setInfo(
      {
        en: "Base-10 logarithm of E"
      }
    ),

    LomaVariable.create( "LOG2E", Math.LOG2E, DataTypes.Number ).setInfo(
      {
        en: "Base-2 logarithm of E"
      }
    )
  ]

  static functions:LomaFunction[] =
  [
    LomaFunction.forNumberIO( "log", "value", ( value ) => Math.log( value )    
    ).setInfo( { en: "Returns the logarithmus of the value" }),

    LomaFunction.forNumberIO( "exp", "value", ( value ) => Math.exp( value )    
    ).setInfo( { en: "Returns 'e' raised to the power of the value" }),

    LomaFunction.forNumbersWith( "base", [ "exponent", "power" ], ( values ) => MathX.base( values[ 0 ], values[ 1 ] )    
    ).setInfo( { en: "Returns the base of the equation: base ^ exponent = power" }),

    LomaFunction.forNumbersWith( "exponent", [ "base", "power" ], ( values ) => MathX.exponent( values[ 0 ], values[ 1 ] )   
    ).setInfo( { en: "Returns the exponent of the equation: base ^ exponent = power" })
  ]   
  
}